<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>服务台</span>
                        <span>事件来源统计</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table
                                :data="tableData">
                                <el-table-column prop="num1" label="监控生成"></el-table-column>
                                <el-table-column prop="num2" label="微信报警"></el-table-column>
                                <el-table-column prop="num3" label="邮件推送"></el-table-column>
                            </el-table>
                        </div>
                        <div ref="myChart"></div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>2019-09-06 10:43:37</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    export default {
        data: function () {
            return {
                tableData: [
                    {num1: '10',num2:'90',num3:'60'},
                ],
                sortList:['descending', 'ascending'],
                value:'',
                options:{
                    tooltip : {},
                    legend: {},
                    dataset:{
                        source:[
                            ['','监控生成','微信报警','邮件推送'],
                            ['监控生成','10'],
                            ['微信报警','90'],
                            ['邮件推送','60']
                        ]
                    },
                    series: [
                        {
                            type:'pie',
                        },
                    ]
                },
            }
        },
        mounted(){
            this.getEcharts();
        },
        methods:{
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                alert(12)
            },
            getEcharts(item){//实例化图标
                let myChart = this.$echarts.init(this.$refs.myChart);
                myChart.setOption(this.options);
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .tableClass{
        display: flex;
        &>div:nth-child(1){
            width: 40%;
        }
        &>div:nth-child(2){
            width: 60%;
            height:400px;
        }
    }
</style>
